import { betStore, gameStore, roundStore, translationStore, userStore } from '../stores';
import { gameConnection } from '../signalR/gameConnection';
import { IGameInitializeModel } from '../interfaces/game';
import { RoundStatus } from '../enums/round-status';
import { roundService } from './roundService';
import { translationApiService } from '../api/translationApiService';
import { userService } from './userService';
import { IBet } from "../interfaces/bet";

class GameService {

  initializeGame = () => {
    window.addEventListener('message', this.onMessage);
    window.parent.postMessage({ event: 'game-preloaded' }, '*');
  };

  initializeData = (data: IGameInitializeModel) => {
    this.setDurations(data);
    this.setStatistics(data);
    this.checkRoundStatusAndMakeAction(data);
    this.setCurrentBets(data.bets);
    gameStore.setLobbyEnabled(data.lobbyEnabled);
    gameStore.setMinBetAmount(data.minBet);
    gameStore.setMaxBetAmount(data.maxBet);
    gameStore.setMaxWinAmount(data.maxWin);
    gameStore.setDefaultBetAmount(data.defaultBet);
    gameStore.setQuickBets(data.quickBets);
    betStore.setAmount(data.defaultBet);
    roundStore.setRoundId(data.round.id);
    gameStore.setLastRounds(data.lastRounds);
    betStore.setAllBetsCount(data.bets.length);
    roundStore.setRoundStatus(data.round.status);
    window.parent.postMessage({ event: 'game-loaded' }, '*');
  };

  handleInitializeGameError = (_error: string) => {
    // const t = useTranslation();
    // notificationService.show(t(error), 'error');
  }

  private onMessage = ({ data }: any) => {
    switch (data.event) {
      case 'access-token-received':
        this.openGame(data.accessToken);
        break;
    }
  }

  private openGame = (accessToken: string) => {
    userStore.setAccessToken(accessToken);

    if (!gameStore.gameInitialized) {
      userService.updateUserBalance().then();
      Promise.all([gameConnection.connect(), this.setTranslations()])
        .then(() => {
          gameStore.setGameInitialized(true);
        });
    }
  }

  private setDurations = (data: IGameInitializeModel) => {
    gameStore.reportDuration = data.reportDuration;
    gameStore.betCloseToReportDuration = data.betCloseToReportDuration;
    gameStore.reportToRoundFinishDuration = data.reportToRoundFinishDuration;
    gameStore.roundStartToBetCloseDuration = data.roundStartToBetCloseDuration;
    gameStore.roundFinishToRoundStartDuration = data.roundFinishToRoundStartDuration;
  }

  private setStatistics = (data: IGameInitializeModel) => {
    gameStore.setStatistics(data.statistics);
  }

  private checkRoundStatusAndMakeAction = (data: IGameInitializeModel) => {
    const { round } = data;
    if (round.status === RoundStatus.Started) {
      const now = new Date(round.startedAt!).getTime();
      const endTime = now + gameStore.roundStartToBetCloseDuration;
      roundService.startCountdown(endTime);
    }

    roundStore.setOpenedNumber(round.numbers);
  }

  private setTranslations = async () => {
    const data = await translationApiService.getTranslations();
    translationStore.setTranslations(data);
  }

  private setCurrentBets = (betsToProcess: IBet[]) => {
    const bets: IBet[] = [];
    betsToProcess.forEach((bet) => {
      if (bet.userId == userStore.id) {
        bets.unshift(bet);
      } else {
        bets.push(bet);
      }
    });

    betStore.setCurrentBets(bets);
  }

}

export const gameService = new GameService();
